import Product from '../model/Product'

const CrossSellService = function (Cart, $q, Discount) {
  /*execStatus - object that stores the execution status of different $scope actions
   - possible values 0-error, 1-success, 2-in progress
   */
  var execStatus = {
    products: {}, productCategories: {}, addProducts: {}
  };

  // ---- Numeric helpers to avoid NaN in Cart.sum ----
  function toAmount(v) {
    if (v == null) return 0;
    if (typeof v === 'string') v = v.replace(',', '.');
    var n = parseFloat(v);
    return isFinite(n) ? n : 0;
  }

  function sanitizeScopeNumbers($scope) {
    if (!$scope) return;
    if ($scope.Cart) {
      $scope.Cart.shippingPrice = toAmount($scope.Cart.shippingPrice);
      $scope.Cart.fees          = toAmount($scope.Cart.fees);
      $scope.Cart.discountTotal = toAmount($scope.Cart.discountTotal);
      $scope.Cart.sum           = toAmount($scope.Cart.sum);
    }
    if ($scope.cartItems) {
      Object.keys($scope.cartItems).forEach(function(k){
        var it = $scope.cartItems[k];
        if (!it) return;
        it.price  = toAmount(it.price || it.unitPrice || (it.item && it.item.price));
        it.amount = toAmount(it.amount || it.qty || it.quantity || 1);
      });
    }
  }

  function recalcScopeSum($scope) {
    if (!$scope || !$scope.Cart) return 0;
    var items = [];
    if ($scope.cartItems) {
      Object.keys($scope.cartItems).forEach(function(k){
        var it = $scope.cartItems[k];
        if (!it) return;
        items.push(it);
      });
    }
    var itemsTotal = items.reduce(function(acc, it){
      return acc + toAmount(it.price) * toAmount(it.amount);
    }, 0);
    var shipping = toAmount($scope.Cart.shippingPrice);
    var fees     = toAmount($scope.Cart.fees);
    var discount = toAmount($scope.Cart.discountTotal);
    var sum = itemsTotal + shipping + fees - discount;
    $scope.Cart.sum = sum;
    return sum;
  }
  // ---- /Numeric helpers ----

  var service = {
    deprecated: { $scope: null },

    moreGiftWrapperAllowed: 0,

    /**
     * @type {Product[]}
     */
    products: {},
    productCategories: {},

    productCountInCategory: function (productCategory) {
      var count = 0;

      for (var key in this.products[ productCategory.id ]) {
        if (!this.products[ productCategory.id ].hasOwnProperty(key)) {
          continue;
        }
        count++;
      }

      return count;
    },
    /**
     *
     * @param {ProductCategory} productCategory
     * @return {Product[]}
     */
    getProductsOfCategory: function (productCategory) {
      return this.products[ productCategory.id ] ? this.products[ productCategory.id ] : [];
    },

    setMoreGiftWrapperAllowed: function (moreGiftWrapperAllowed) {
      this.moreGiftWrapperAllowed = parseInt(moreGiftWrapperAllowed);
    },
    initProducts: function () {
      this.products = {};
    },
    initProductCategories: function () {
      this.productCategories = {};
    },
    setCrossSellProductsByCheckoutOptions: function (checkoutOptions) {
      this.initProducts();
      if (typeof checkoutOptions.hasOwnProperty('crossSellProductCategories')) {
        this.initProductCategories();
        for (var catKey in checkoutOptions[ 'crossSellProductCategories' ]) {
          this.productCategories[ catKey ] = checkoutOptions[ 'crossSellProductCategories' ][ catKey ];
        }
        for (var key in this.productCategories) {
          if (!this.productCategories.hasOwnProperty(key)) {
            continue;
          }
          var obj = this.productCategories[ key ];

          if (obj[ 'tags' ]) {
            this.productCategories[ key ][ 'tags' ] = obj[ 'tags' ].split(',');
          } else {
            this.productCategories[ key ][ 'tags' ] = [];
          }
          for (var index in obj.products) {
            if (!obj.products.hasOwnProperty(index)) {
              continue;
            }

            if (!this.products[ obj.id ]) {
              this.products[ obj.id ] = {};
            }
            this.products[ obj.id ][ index ] = new Product(obj.products[ index ]);
          }
        }
      }

      if (typeof checkoutOptions[ 'crossSellProducts' ] !== 'undefined') {
        this.products[ 0 ] = checkoutOptions[ 'crossSellProducts' ];
      }
    },
    setCrossSellProducts: function (productCategoryId) {
      if (!this.productCategories[ productCategoryId ]) {
        this.productCategories[ productCategoryId ] = {};
      }

      if (typeof this.products[ productCategoryId ] === 'undefined') {
        if (!execStatus.productCategories[ productCategoryId ]) {
          execStatus.productCategories[ productCategoryId ] = 2;
          this.deprecated.$scope.ajaxCall('cart', 'getcrosssellproducts', 'POST', { productCategoryId: productCategoryId },
            function (response) {
              execStatus.productCategories[ productCategoryId ] = 1;
              if (typeof response.products === 'object') {

                var validProductIds = service.productCategories[ productCategoryId ][ 'productids' ].split(',');
                var products = {};
                for (var index in response.products) {
                  if (!response.products.hasOwnProperty(index)) {
                    continue;
                  }
                  if (validProductIds.indexOf(index) >= 0) {
                    products[ index ] = new Product(response.products[ index ]);
                  }
                }
                service.products[ productCategoryId ] = products;

                service.productCategories[ productCategoryId ].display = 1;

                if (typeof service.deprecated.$scope.translations.crossSellProducts === 'undefined') {
                  service.deprecated.$scope.translations.crossSellProducts = {};
                }

                service.deprecated.$scope.translations.crossSellProducts[ productCategoryId ] = response.translations;
              }
            },
            function (error) {
              execStatus.productCategories[ productCategoryId ] = 0;
              service.deprecated.$scope.displayError(error);

            }
          );
        }
      } else if (this.productCategories[ productCategoryId ].display) {
        this.productCategories[ productCategoryId ].display = 0;
      } else {
        this.productCategories[ productCategoryId ].display = 1;
      }
      // don't know the purpose of .display
    },

    /**
     *
     * @param {object} product
     * @param {object} productCategory
     * @param {boolean} exclusive
     * @returns {Promise}
     */
    addSingleCrossSellProductToCart: function (product, productCategory, exclusive) {
      this.changeCrossSellProductAmount(product.id, productCategory.id, null, 1);
      return this.addCrossSellProductToCart(product, productCategory, exclusive);
    },

    /**
     *
     * @param {Product} product
     * @param {object} productCategory
     * @param {boolean} exclusive
     * @return {Promise} promise
     */
    addCrossSellProductToCart: function (product, productCategory, exclusive) {
      var deferred = $q.defer();
      var productId = product.id;
      var productCategoryId = productCategory.id;

      if (typeof exclusive === 'undefined') {
        exclusive = false;
      }

      var products = {};
      var addProduct = false;
      var execStatusKey = productCategoryId + productId;

      product.addAction = true;

      if (product.detailData && !execStatus.addProducts[ execStatusKey ]) {
        var amount = 0;
        if (typeof product.detailData.productsizes === 'object') {

          for (var index in product.detailData.productsizes) {

            var productSize = product.detailData.productsizes[ index ];
            amount = parseInt(productSize.amount);



            var key = productId + '-' + productSize.id;

            if (amount > 0 && amount <= productSize.stock) {
              products[ key ] = {
                id: productId,
                amount: amount,
                sizeid: productSize.id,
                productcategoriesid: productCategoryId
              };
            } else {
              products[ key ] = {
                id: productId,
                amount: 0,
                sizeid: productSize.id,
                productcategoriesid: productCategoryId
              };
            } addProduct = true;

          }
        } else {

          amount = parseInt(product.detailData.amount);

          if (amount > 0 && amount <= product.detailData.stock) {

            products[ productId ] = {
              id: productId,
              amount: amount,
              productcategoriesid: productCategoryId
            };
            addProduct = true;
          } else {
            products[ productId ] = {
              id: productId,
              amount: 0,
              productcategoriesid: productCategoryId
            };
            addProduct = true;
          }
        }

        if (addProduct) {
          execStatus.addProducts[ execStatusKey ] = 2;

          this.deprecated.$scope.ajaxCall('cart', 'addProduct', 'POST', { products: products },
            function (response) {
              execStatus.addProducts[ execStatusKey ] = null;

              for (var key in response.products) {
                if (!response.products.hasOwnProperty(key)) {
                  continue;
                }
                var responseProduct = response.products[ key ];
                if (responseProduct.status) {
                  if (responseProduct.product) {
                    responseProduct.product.id = productId;
                    responseProduct.product.productid = key;
                    responseProduct.product.productcategoriesid = productCategoryId;
                    service.deprecated.$scope.cartItems[ 'product-' + key ] = new Product(responseProduct.product);
                    if (responseProduct.message !== undefined && responseProduct.message.length > 0) {
                      service.deprecated.$scope.displayError(responseProduct.message);
                    }
                  } else {
                    delete service.deprecated.$scope.cartItems[ 'product-' + key ];
                  }
                } else if (responseProduct.error !== undefined && responseProduct.error.length > 0) {
                  service.deprecated.$scope.displayError(responseProduct.error);
                }
              }

              // Remove other items of this category from cart if this category is exclusive
              // Todo: Make exlcusive a DB field and accessible in the productcategory
              if (exclusive) {
                for (var key in service.deprecated.$scope.cartItems) {
                  if (!service.deprecated.$scope.cartItems.hasOwnProperty(key)) {
                    continue;
                  }
                  var item = service.deprecated.$scope.cartItems[ key ];
                  if (item.hasOwnProperty("productcategoriesid")) {
                    if ((item.productcategoriesid === productCategoryId) && !(item.id == productId)) {
                      service.deprecated.$scope.removeFromCart(item, key);
                    }
                  }
                }
              }

              service.deprecated.$scope.scrollCartToBottom();
              service.deprecated.$scope.setCheckoutOptions(angular.fromJson(response.checkout_options), angular.fromJson(response.checkout_translations));

              // Sanitize numeric fields and recompute Cart.sum to avoid NaN
              try { sanitizeScopeNumbers(service.deprecated.$scope); } catch(e) { console.warn('[CrossSell] sanitize failed', e); }
              try {
                if (typeof service.deprecated.$scope.updateCartSum === 'function') {
                  service.deprecated.$scope.updateCartSum();
                }
              } catch(e) { console.warn('[CrossSell] updateCartSum() threw', e); }
              try { recalcScopeSum(service.deprecated.$scope); } catch(e) { console.warn('[CrossSell] recalc failed', e); }

              if (response.discount) {
                Discount.setDiscount(response.discount, service.deprecated.$scope);
              }
              deferred.resolve(response);
            },
            function (error) {
              service.deprecated.$scope.displayError(error);

              execStatus.addProducts[ execStatusKey ] = 0;
              deferred.reject(error);
            }
          );
        } else {
          deferred.reject('nothing to add');
        }
      } else {
        deferred.reject('detail Data not set');
      }
      return deferred.promise;
    },
    removeProduct: function (product) {
      this.changeCrossSellProductAmount(product.id, product.productcategoriesid, null, product.amount * -1);
    },
    changeCrossSellProductAmount: function (productId, productCategoryId, productSizeId, amount) {
      if (!this.products[ productCategoryId ] || !this.products[ productCategoryId ][ productId ]) {
        return;
      }
      var newAmount = null;
      var item = this.products[ productCategoryId ][ productId ].detailData;

      if (productSizeId) {
        newAmount = amount + item.productsizes[ productSizeId ].amount * 1;

        if (newAmount <= item.productsizes[ productSizeId ].stock && newAmount >= 0) {
          this.products[ productCategoryId ][ productId ].detailData.productsizes[ productSizeId ].amount = newAmount;
          this.products[ productCategoryId ][ productId ].detailData.totalPrice += amount * toAmount(item.price);
        }
      } else {
        newAmount = amount + item.amount * 1;

        if (newAmount <= item.stock && newAmount >= 0) {
          this.products[ productCategoryId ][ productId ].detailData.amount = newAmount;
          this.products[ productCategoryId ][ productId ].detailData.totalPrice = newAmount * toAmount(item.price);
        }
      }
    },
    unselectOtherProducts: function (productCategoryID, productID) {
      var input = document.getElementById('crosssell-' + productCategoryID + '-' + productID);
      var other = document.querySelectorAll('[data-crosssell-category="' + productCategoryID + '"]');
      for (var i = 0; i < other.length; i++) {
        var el = other[ i ];
        if (el instanceof HTMLInputElement) {
          el.checked = false;
        }
      }
      if (input) {
        input.checked = true;
      }
    },
    /**
     * @param {object} productCategory
     * @param {object} product
     * @return {Promise}
     */
    removeSingleCrossSellProductFromCart: function (productCategory, product) {
      var deferred = $q.defer();
      var productCategoryID = productCategory.id;
      var productID = product.id;
      this.changeCrossSellProductAmount(productID, productCategoryID, null, -1);
      if (parseInt(product.detailData.amount) > 0) {
        service.addCrossSellProductToCart(product, productCategory, false)
          .then(function (response) {
            try { sanitizeScopeNumbers(service.deprecated.$scope); recalcScopeSum(service.deprecated.$scope); } catch(e) { console.warn('[CrossSell] recalc after remove/add failed', e); }
            deferred.resolve(response);
          });
      } else {
        for (var key in this.deprecated.$scope.cartItems) {
          if (!this.deprecated.$scope.cartItems.hasOwnProperty(key)) {
            continue;
          }
          var item = this.deprecated.$scope.cartItems[ key ];
          if (item.hasOwnProperty("productcategoriesid")) {
            if ((item.productcategoriesid === productCategoryID) && (item.id == productID)) {

              this.deprecated.$scope.removeFromCart(item, key);
              var checkbox = document.getElementById('crosssell-' + productCategoryID + '-' + productID);
              if (checkbox) {
                checkbox.checked = false;
              }
            }
          }
        }
        try { sanitizeScopeNumbers(service.deprecated.$scope); recalcScopeSum(service.deprecated.$scope); } catch(e) { console.warn('[CrossSell] recalc after direct remove failed', e); }
        deferred.resolve({});
      }
      return deferred.promise;
    },
    /**
     *
     * @param {object} product
     * @param {object} productCategory
     * @returns {Promise}
     */
    toggleCrossSellProduct: function (product, productCategory) {
      var promise;
      var productID = product.id;
      var productCategoryID = productCategory.id;
      // remove From Card if it has the product and uncheck product
      if (Cart.cartHasProductID(productID, productCategoryID)) {
        promise = this.removeSingleCrossSellProductFromCart(productCategory, product);
      } else {
        promise = this.addSingleCrossSellProductToCart(product, productCategory, true);
        this.unselectOtherProducts(productCategoryID, productID);
        var element = document.getElementById('crosssell-' + productCategoryID + '-' + productID);
        if (element) {
          element.checked = true;
        }
      }
      return promise;
    },
    loadCrossSellProductDetail: function (product, productCategory) {
      var productId = product.id;
      var productCategoryId = productCategory.id;
      if (typeof this.products[ productCategoryId ][ productId ].detailData === 'undefined') {
        var execStatusKey = productCategoryId + '' + productId;

        if (!execStatus.products[ execStatusKey ]) {
          execStatus.products[ execStatusKey ] = 2;

          this.deprecated.$scope.ajaxCall('cart', 'getcrosssellproductdetail', 'POST', { productid: productId },
            function (response) {
              execStatus.products[ execStatusKey ] = 1;

              if (typeof response.product === 'object') {
                service.products[ productCategoryId ][ productId ].detailData = response.product;
                if (service.products[ productCategoryId ][ productId ].detailData.amount === null) {
                  service.products[ productCategoryId ][ productId ].detailData.amount = 0;
                }
                service.products[ productCategoryId ][ productId ].detailData.display = 1;
              }

            },
            function (error) {
              service.deprecated.$scope.displayError(error);
              execStatus.products[ execStatusKey ] = 0;
            }
          );
        }
      } else {
        this.products[ productCategoryId ][ productId ].detailData.display = 1;
      }
    },

    factory: function ($scope) {
      this.deprecated.$scope = $scope;
    }
  };
  return service;
};

export default CrossSellService;
